import { render, staticRenderFns } from "./CommercialProduct.vue?vue&type=template&id=15fc2401&scoped=true&"
import script from "./CommercialProduct.vue?vue&type=script&lang=js&"
export * from "./CommercialProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fc2401",
  null
  
)

export default component.exports